'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { CardExpiryField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-expiry.tsx';
import { CreditCardFields } from '@sola/ark-core/molecules/credit-card-fields/credit-card-fields.tsx';
import { CardNameField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-name.tsx';
import { InputField } from '@sola/ark-core/molecules/input-field/input-field.tsx';
import { SupporterCCFieldsEnum } from '@sola/schema/dotcom/supporters/paymentMethods.ts';
import { GraphQLSupporterPaymentMethod } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { getShortExpiryDate } from '@sola/shared-utils/credit-cards.ts';
export interface UpdateCCFields {
  paymentMethod: GraphQLSupporterPaymentMethod;
}
export const UpdateCCFields: React.FC<UpdateCCFields> = t0 => {
  const $ = _c(18);
  const {
    paymentMethod
  } = t0;
  const {
    t
  } = useTranslation("my");
  const t1 = paymentMethod.creditCard?.expirationDate ?? "";
  let t2;
  if ($[0] !== t1) {
    t2 = getShortExpiryDate(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <CardExpiryField name={SupporterCCFieldsEnum.expirationDate} value={t2} required={true} validateCurrentMonth={true} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = paymentMethod.creditCard?.cardholderName;
  let t5;
  if ($[4] !== t4) {
    t5 = <CardNameField name={SupporterCCFieldsEnum.nameOnCard} value={t4} required={true} />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t) {
    t6 = t("payments.methodForm.fieldLabels.cardNickname");
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = paymentMethod.accountNickname;
  let t8;
  if ($[8] !== t) {
    t8 = t("payments.methodForm.fieldLabels.optional");
    $[8] = t;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== paymentMethod.accountNickname || $[11] !== t6 || $[12] !== t8) {
    t9 = <InputField name={SupporterCCFieldsEnum.nickname} label={t6} value={t7} hint={t8} />;
    $[10] = paymentMethod.accountNickname;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t3 || $[15] !== t5 || $[16] !== t9) {
    t10 = <CreditCardFields>{t3}{t5}{t9}</CreditCardFields>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};